import { render, staticRenderFns } from "./AdminFinalExamAdminListView.vue?vue&type=template&id=b0c2e9b2"
import script from "./AdminFinalExamAdminListView.vue?vue&type=script&lang=js"
export * from "./AdminFinalExamAdminListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports